import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { TaiLieu } from './tai-lieu';
import { TaiLieuKy } from './danh-sach-tai-lieu';

export default function QuanLyTaiLieu() {
  return (
    <Routes>
      <Route path="tai-lieu/:agreementId" element={<TaiLieu />} />
      <Route path="danh-sach-tai-lieu" element={<TaiLieuKy />} />
      {/* Redirect /tai-lieu to list since we now create from there */}
    </Routes>
  );
}
